import React, { useState } from 'react';

/**
 *
 * @param {Object} props
 * @param {Agente} props.currentAgent
 * @returns {JSX.Element}
 * @constructor
 */
export default function Panel(props) {
  const [name, setName] = useState('')
  const style = {
    left: props.isOpen ? "0" : "-110%",
  };

  const handleSubmit = (e) => {
    e.preventDefault()
    props
      .createBroadcastList(props.currentAgent.usuario.emailreal, name)
      .then(broadcastList => {
        const members = props.broadcastListMembers.map(x => ({ clientNumber: x.numeroCliente, phoneNumber: x.telefonoCelular }) )
        return props.appendBroadcastListMembers(props.currentAgent.usuario.emailreal, broadcastList, members)
      })
      .then(() => {
        props.cleanUp()
        props.close()
        props.loadBroadcastLists(props.currentAgent.usuario.emailreal)
      })
  }

  const handleChange = (e) => {
    const query = e.target.value.trim()
    setName(query)
  }

  return (
    <div className="d-flex flex-column w-100 h-100 left-panel" style={style}>
      <form onSubmit={handleSubmit.bind(this)}>
        <div className="row d-flex flex-row align-items-center p-2 m-0" style={{backgroundColor:"white", minHeight:"65px"}}>
            <i className="fas fa-arrow-left p-2 mx-3 my-1" style={{fontSize: "1.5rem", cursor: "pointer"}} onClick={props.close}></i>
            <div className="font-weight-bold">Nueva difusión</div>
        </div>
        <div className="d-flex flex-column" style={{overflow:"auto"}}>
          <div className="row d-flex flex-row align-items-center p-2 m-0 justify-content-center" style={{width: "100%", height: "200px"}}>
            <i className="fas fa-users" style={{fontSize: "60pt", color: "lightslategrey"}}></i>
          </div>
          <div className="px-3 py-2">
            <div className="input-group mb-3">
              <input
                focus={"true"}
                style={{background: "none"}}
                type="text"
                className="input-wa"
                maxLength="50"
                required={true}
                onChange={handleChange}
                placeholder="Nombre de la difusión" />
            </div>
          </div>
        </div>
        {
          name.length > 0 ? (
            <div className="row d-flex flex-row align-items-center p-2 m-0 justify-content-center">
                <button type="submit" style={{borderRadius:"25px"}} className="btn btn-success btn-icon"> <i className="fa fa-arrow-right"></i> </button>
            </div>
          ): null
        }
      </form>
    </div>
  )
}
